module.exports = __webpack_public_path__ + "img/ts01.50fb254f.png";